export default __webpack_public_path__ + "static/media/livingroom3.bc83302a.webp";